module.exports = __webpack_public_path__ + "static/img/service_illustration_h5_zh.e3fe153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_illustration_h5_zh.png
// module id = 2bqU
// module chunks = 34